import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface OwnerAuthState {
  loading: boolean;
  error?: string | null;
  accessToken: string;
  refreshToken: string;
  emailOrUsername: string; // stored for refresh purposes if needed
}

const initialState: OwnerAuthState = {
  loading: false,
  error: null,
  accessToken: '',
  refreshToken: '',
  emailOrUsername: '',
};

const ownerAuthSlice = createSlice({
  name: 'backofficeOwnerAuth',
  initialState,
  reducers: {
    setOwnerAuthLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setOwnerAuthError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setOwnerTokens: (
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>,
    ) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    setOwnerIdentifier: (state, action: PayloadAction<string>) => {
      state.emailOrUsername = action.payload;
    },
    clearOwnerTokens: state => {
      state.accessToken = '';
      state.refreshToken = '';
    },
  },
});

export const {
  setOwnerAuthLoading,
  setOwnerAuthError,
  setOwnerTokens,
  setOwnerIdentifier,
  clearOwnerTokens,
} = ownerAuthSlice.actions;
export default ownerAuthSlice.reducer;
